export default "__VITE_ASSET__v2434umr__"